import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/905321234567?text=Merhaba,%20kurs%20bilgisi%20almak%20istiyorum."
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-30 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20BF5B] text-white shadow-[0_10px_30px_rgba(37,211,102,0.4)] flex items-center justify-center transition-transform hover:scale-110"
      aria-label="WhatsApp iletişim"
    >
      <MessageCircle size={26} strokeWidth={2} />
    </a>
  );
}
